import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { LiveTrackerIframe } from 'src/domains/sportsbook/webview/components/scoreboards/liveTracker/LiveTrackerIframe';
import { getLiveTrackerContainerConfig } from 'src/domains/sportsbook/webview/components/scoreboards/liveTracker/ContainerConfig';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    sport: string;
    eventId: number;
    isOpen: boolean;
}

export const LiveTracker = observer('LiveTracker', ({ sport, eventId, isOpen }: PropsType): JSX.Element | null => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const { scoreboard, liveTracker } = config;

    if (scoreboard.liveTracker === null || liveTracker === null) {
        return null;
    }

    for (const item of scoreboard.liveTracker) {
        const containerConfigItem = getLiveTrackerContainerConfig(liveTracker.scriptSrcUrl)[item];

        if (item === sport && containerConfigItem !== undefined) {
            return (
                <LiveTrackerIframe
                    eventId={eventId}
                    providerName={liveTracker.providerName}
                    containerConfig={containerConfigItem}
                    isOpen={isOpen}
                />
            );
        }
    }

    return null;
});
